<div class="loadingGif">
  <img src="../../../assets/img/regp-logo.png" />
  <div>
    <div></div>			
  </div>
</div>
